import React, { useState } from "react";
import { Field } from "../components/Field";
import { createProposal, getApiBase, type ProposalPayload } from "../services/api";
import { formatBRLInput, toNumberBRL } from "../utils/money";

export function GenerateProposalPage() {
  const [companyName, setCompanyName] = useState("");
  const [idadeEmpresa, setIdadeEmpresa] = useState("12");
  const [contab, setContab] = useState("");
  const [acomp, setAcomp] = useState("");

  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<{ id: string; downloadUrl: string } | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    const companyAge = parseInt(idadeEmpresa, 10);
    const payload: ProposalPayload = {
      companyName: companyName.trim(),
      companyAge: Number.isFinite(companyAge) && companyAge >= 0 ? companyAge : 12,
      contabilidadeTradicional: toNumberBRL(contab),
      gestaoTributariaAcompanhamento: toNumberBRL(acomp),
      consultoriaMensal: 0
    };

    if (payload.companyName.length < 2) return setError("Informe o nome da empresa cliente.");
    if (!Number.isFinite(payload.companyAge) || payload.companyAge < 0 || payload.companyAge > 200) {
      return setError("Informe a idade da empresa (0 a 200 anos).");
    }
    if (!Number.isFinite(payload.contabilidadeTradicional)) {
      return setError("Informe um valor válido para Contabilidade tradicional.");
    }
    if (!Number.isFinite(payload.gestaoTributariaAcompanhamento)) {
      return setError("Informe um valor válido para Honorários Contábeis NCC.");
    }
    setBusy(true);
    try {
      const res = await createProposal(payload);
      setSuccess({ id: res.id, downloadUrl: res.downloadUrl });

      // Baixar automaticamente – nome: "Proposta - Nome cliente.pdf"
      const pdfRes = await fetch(`${getApiBase()}${res.downloadUrl}`);
      if (!pdfRes.ok) throw new Error("Falha ao baixar o PDF gerado.");
      const blob = await pdfRes.blob();
      const url = URL.createObjectURL(blob);
      const nomeSeguro = ((payload.companyName || "Cliente").replace(/[/\\:*?"<>|]/g, "").trim() || "Cliente").toUpperCase();
      const a = document.createElement("a");
      a.href = url;
      a.download = `Proposta - ${nomeSeguro}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Falha ao gerar PDF.";
      setError(msg);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="proposal-page">
      <div className="proposal-inner">
        <div className="proposal-header">
          <img src="/logo.png" alt="NCC" className="proposal-logo" />
          <div className="proposal-title">NCC Gerador de Proposta Comercial</div>
        </div>

        <div className="proposal-card">
          <form onSubmit={onSubmit}>
            <div className="proposal-grid">
              <div className="proposal-grid-item-full">
                <Field
                  label="Nome da empresa cliente"
                  value={companyName}
                  onChange={setCompanyName}
                  placeholder="Ex.: ACME Indústria e Comércio LTDA"
                />
              </div>

              <Field
                label="Idade da empresa (anos)"
                value={idadeEmpresa}
                onChange={setIdadeEmpresa}
                inputMode="numeric"
                placeholder="12"
              />
              <Field
                label="Contabilidade tradicional (R$)"
                value={contab}
                onChange={(v) => setContab(formatBRLInput(v))}
                inputMode="numeric"
                placeholder="0,00"
              />
              <Field
                label="Honorários Contábeis NCC (R$)"
                value={acomp}
                onChange={(v) => setAcomp(formatBRLInput(v))}
                inputMode="numeric"
                placeholder="0,00"
              />
            </div>

            <div className="proposal-actions">
              <button
                type="submit"
                disabled={busy}
                className="proposal-btn"
              >
                {busy ? "Gerando..." : "Gerar PDF"}
              </button>

              {error ? (
                <div className="proposal-msg proposal-msg--error">{error}</div>
              ) : success ? (
                <div className="proposal-msg proposal-msg--ok">PDF gerado com sucesso.</div>
              ) : null}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

